import React from 'react';
import { Card } from 'react-bootstrap';

const OrderDetailsTable = ({ 
  orderDetails, 
  title = "Estimated Closing Orders",
  showCount = true 
}) => {
  if (!orderDetails || orderDetails.length === 0) {
    return null;
  }

  return (
    <Card className="main-card mt-3">
      <Card.Header className="card-header-custom">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fw-bold">
            {/* <i className="fas fa-table me-2"></i> */}
            {title} 
          </h5>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        <div className="table-responsive">
          <table className="table-modern mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '9rem' }}><i className="fas fa-hashtag me-1"></i>Order No.</th>
                <th style={{ width: '9rem' }}><i className="fas fa-info-circle me-1"></i>Status</th>
                <th style={{ width: '15rem' }}><i className="fas fa-user-tie me-1"></i>Transaction Coordinator</th>
                <th style={{ width: '12rem' }}><i className="fas fa-calendar-check me-1"></i>Expected Closing</th>
                <th><i className="fas fa-map-marker-alt me-1"></i>Closing Location</th>
                <th><i className="fas fa-home me-1"></i>Property Address</th>
                <th><i className="fas fa-tags me-1"></i>Overview</th>
                <th><i className="fas fa-tags me-1"></i>Automation Status</th>
              </tr>
            </thead>
            <tbody>
              {orderDetails.map((order, index) => (
                <tr key={index} className="table-row-clickable">
                  <td style={{ width: '9rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <span className="id-badge">{order.order_number}</span>
                  </td>
                  <td style={{ width: '7rem', whiteSpace: 'nowrap' }}>
                    <div 
                      className={`status-badge-professional status-${order.status?.toLowerCase()==="open"?"closed":"open"}`}
                      style={{
                        color: 'white',
                        padding: '0.4rem 0.8rem',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        fontWeight: '600',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.4rem',
                        border: 'none',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        minWidth: '85px',
                        justifyContent: 'center'
                      }}
                    >
                      <span style={{ fontSize: '0.9rem' }}>
                        {order.status === 'OPEN' ? '✗' : order.status === 'CLOSED' ? '✓' : '●'}
                      </span>
                      <span>{order.status}</span>
                    </div>
                  </td>

                  {/* Transaction Coordinator (first + last name, filtered by role) */}
                  <td style={{ width: '15rem', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    <div className="text-primarys fw-medium" style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                      {(() => {
                        const team = Array.isArray(order.settlement_team) ? order.settlement_team : [];
                        const coordinators = team.filter(m => (m?.role || '').toLowerCase() === 'transaction coordinator');
                        if (coordinators.length === 0) {
                          return <span className="text-muted fst-italic">Not Available</span>;
                        }
                        return coordinators.map((m, idx) => {
                          const fullName = [m?.firstName, m?.lastName].filter(Boolean).join(' ').trim();
                          return (
                            <div key={idx} className="mb-1">
                              <span className="text-primarys fw-medium">{fullName || 'Unknown'}</span>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </td>
                  
                  <td style={{ width: '12rem', whiteSpace: 'nowrap' }}>
                    <div className="date-cell">
                      {(() => {
                        if (!order.estimated_closing) {
                          return 'Not Available';
                        }
                        const date = new Date(order.estimated_closing + 'T00:00:00Z');
                        if (isNaN(date.getTime())) {
                          return 'Not Available';
                        }
                        return date.toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                          timeZone: 'UTC'
                        });
                      })()}
                    </div>
                  </td>
                  <td>
                    <div className="address-cell" style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                      {order.closing_address ? (
                        <span className="text-primarys fw-medium">{order.closing_address}</span>
                      ) : (
                        <span className="text-muted fst-italic">Not Available</span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="address-cell" style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                      {order.property_addresses && order.property_addresses.length > 0 ? (
                        <div>
                          {order.property_addresses.map((address, idx) => (
                            <div key={idx} className="mb-1">
                              <span className="text-success fw-medium">{address}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted fst-italic">Not Available</span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div 
                      className={`app-status-badge app-status-${order.app_status?.replace(/_/g, '-') || 'unknown'}`}
                      style={{
                        backgroundColor: order.app_status === 'refinance' ? '#6f42c1' :
                                        order.app_status?.includes('fsbo') ? '#fd7e14' :
                                        order.app_status?.includes('agent_copies_exists') ? '#198754' :
                                        order.app_status?.includes('no_agent_copies') ? '#dc3545' :
                                        order.app_status?.includes('no_listing_no_selling') ? '#6c757d' :
                                        '#0d6efd',
                        color: 'white',
                        padding: '0.3rem 0.6rem',
                        borderRadius: '6px',
                        fontSize: '0.65rem',
                        fontWeight: '500',
                        display: 'inline-block',
                        textAlign: 'center',
                        textTransform: 'capitalize',
                        letterSpacing: '0.2px'
                      }}
                      title={order.app_status ? order.app_status.replace(/_/g, ' ').toUpperCase() : 'Unknown'}
                    >
                      {order.app_status ? 
                        order.app_status.replace(/_/g, ' ').replace(/but/g, '-').trim() 
                        : 'Unknown'
                      }
                    </div>
                  </td>
                  <td>
                    {(() => {
                      const cs = (order.completion_status || '').toLowerCase();
                      const getConfig = (val) => {
                        switch (val) {
                          case 'completed':
                            return { gradient: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)', shadow: '0 4px 15px rgba(40, 167, 69, 0.3)', icon: '✓' };
                          case 'both_agents_present':
                            return { gradient: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)', shadow: '0 4px 15px rgba(40, 167, 69, 0.3)', icon: '✓' };
                          case 'listing_agents_only':
                          case 'selling_agents_only':
                            return { gradient: 'linear-gradient(135deg, #007bff 0%, #6610f2 100%)', shadow: '0 4px 15px rgba(0, 123, 255, 0.3)', icon: '✗' };
                          case 'fsbo_no_agents':
                            return { gradient: 'linear-gradient(135deg, #fd7e14 0%, #ffc107 100%)', shadow: '0 4px 15px rgba(253, 126, 20, 0.3)', icon: '✗' };
                          case 'agent_copy_missing':
                          case 'both_agents_missing':
                            return { gradient: 'linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)', shadow: '0 4px 15px rgba(220, 53, 69, 0.3)', icon: '✗' };
                          case 'refinance':
                            return { gradient: 'linear-gradient(135deg, #6f42c1 0%, #b37feb 100%)', shadow: '0 4px 15px rgba(111, 66, 193, 0.3)', icon: '✗' };
                          default:
                            return { gradient: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)', shadow: '0 4px 15px rgba(108, 117, 125, 0.3)', icon: '●' };
                        }
                      };
                      const cfg = getConfig(cs);
                      const displayText = (() => {
                        switch (cs) {
                          case 'both_agents_present': return 'Both Agents Present';
                          case 'listing_agents_only': return 'Listing Agents Only';
                          case 'selling_agents_only': return 'Selling Agents Only';
                          case 'fsbo_no_agents': return 'FSBO';
                          case 'agent_copy_missing': return 'Agent Copy Missing';
                          case 'both_agents_missing': return 'Both Agents Missing';
                          case 'completed': return 'Completed';
                          case 'refinance': return 'Refinance';
                          case 'fsbo_but_selling_agents': return 'FSBO, ONLY S/A';
                          case 'fsbo_but_listing_agents': return 'FSBO, ONLY L/A';
                          default: return 'Pending';
                        }
                      })();
                      return (
                        <div
                          className="status-badge-professional"
                          style={{
                            background: cfg.gradient,
                            boxShadow: cfg.shadow,
                            color: 'white',
                            padding: '0.4rem 0.8rem',
                            borderRadius: '8px',
                            fontSize: '0.7rem',
                            fontWeight: '600',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                            border: 'none',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            transition: 'all 0.3s ease',
                            cursor: 'default',
                            minWidth: '85px',
                            justifyContent: 'center'
                          }}
                          title={displayText}
                        >
                          <span className="status-icon" style={{ fontSize: '0.9rem', display: 'inline-block' }}>{cfg.icon}</span>
                          <span>{displayText}</span>
                        </div>
                      );
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OrderDetailsTable;